export default __webpack_public_path__ + "static/media/ernesto-barbero.041f1671.webp";